export const WELCOME_TOKEN_GRANT = 3;
export const REFERRAL_TOKEN_BONUS = 1;

/**
 * Starting token balance for a new account.
 * @param {string|null} referralCode
 * @returns {number}
 */
export function welcomeTokenAmount(referralCode) {
  return WELCOME_TOKEN_GRANT + (referralCode ? REFERRAL_TOKEN_BONUS : 0);
}
